<template>
  <div>
    <vs-popup
      fullscreen
      class="profile-card"
      title="Editor"
      :active.sync="flag"
    >
      <iframe
        :src="`/gala/editor/preview?organization='gala'`"
        fullscreen
        frameBorder="0"
        id="editorGala"
        class="editor-iframe"
      ></iframe>
    </vs-popup>
    <vs-popup
      class="profile-card"
      width="1100px"
      :title="title"
      :active.sync="profileCardPopupActive"
    >
      <div class="vx-row mb-base">
        <div
          class="vx-col w-full lg:w-1/3 xl:w-1/3 items-center"
          style="position: relative"
        >
          <vs-avatar class="profile-picture" size="100px" :src="src" />
        </div>
        <div class="vx-col w-full lg:w-2/3 xl:w-2/3">
          <h1>{{ name }}</h1>
          <p class="mt-4">{{ description }}</p>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="profile-card"
      :title="title"
      :active.sync="systemCardPopupActive"
    >
      <div class="vx-row mb-base">
        <div class="vx-col w-full lg:w-4/4 xl:w-4/4">
          <p>{{ description }}</p>
          <a :href="joinLink" target="_blank"
            ><vs-button
              text-align="right"
              class="mt-4"
              style="float: right"
              color="primary"
              >Join</vs-button
            ></a
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="profile-card"
      title="Pledge to the Code"
      :active.sync="pledgePopup"
    >
      <div class="vx-row mb-base">
        <div class="vx-col w-full lg:w-4/4 xl:w-4/4">
          <p>
            Your pledge has been made. Soon you will know who is the mentor that
            will be by your side in the incoming challenges.
          </p>
        </div>
      </div>
    </vs-popup>
    <section class="bg-white">
      <div class="container w-full lg:w-3/4">
        <div>
          <!--          <h1 class="mb-3 text-left">{{ $t("alex.myPath") }}</h1>-->
          <!--          <p class="section&#45;&#45;p text-base m-0">-->
          <!--            {{ $t("alex.myPathDesc") }}-->
          <!--          </p>-->
        </div>

        <div
          class="step mt-12"
          :class="autoLoginToken ? 'status-1' : 'status-0'"
        >
          <div class="flex">
            <div class="line mt-12"></div>
            <div id="outerContainer">
              <div id="container">
                <div class="item mr-12"></div>
                <div class="circle" style="animation-delay: 0s"></div>
                <div class="circle" style="animation-delay: 1s"></div>
                <div class="circle" style="animation-delay: 2s"></div>
                <div class="circle" style="animation-delay: 3s"></div>
              </div>
            </div>
            <!--            <img-->
            <!--              src="../../../../../../src/assets/images/gala-images/circle_num/start_0.svg"-->
            <!--              class="checkpoint-circle user-drag-none absolute logo"-->
            <!--            />-->
          </div>
          <div class="flex flex-wrap w-full">
            <div class="w-full md:w-1/1 p-3">
              <vx-card
                :class="isUserLoggedIn ? 'active' : 'inactive'"
                style="border: none; border-radius: 12px"
              >
                <div class="flex">
                  <div class="flex flex-wrap">
                    <vs-row>
                      <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                        <img
                          src="../../../../../assets/images/gala-images/logo_branded/GALAWERSEbg.png"
                          width="100%"
                          height="auto"
                        />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-lg="11" vs-sm="12" vs-xs="12">
                        <p class="s-head"></p>

                        <h5 class="mb-2 font-bold mt-4" style="color: #626262">
                          Welcome, Galaxian
                        </h5>
                        <p style="color: #808080">
                          At your first glance into the Gala Games realm, you
                          will already be able to perceive its innate magic. The
                          only way to see this magical kingdom is through the
                          vision of high-speed internet and your trusty screens.
                          Gala Games is committed to be a 100% remote company
                          that allows adventurers such as yourself to access
                          this realm from wherever you are in the world. Once
                          you are comfortable with this fact, let us proceed to
                          learn a bit more about Gala Games.
                        </p>
                      </vs-col>
                      <vs-col vs-lg="1" vs-sm="12" vs-xs="12">
                        <!--                             <img-->
                        <!--                               v-if="isUserLoggedIn"-->
                        <!--                               src="../../../../../assets/images/icons/gala/right-arrow-blue.svg"-->
                        <!--                               width="45px"-->
                        <!--                               class=" mt-12 ml-12"-->
                        <!--                               style="float:right;"-->
                        <!--                               height="auto"-->
                        <!--                               @click="showTutorial = true"-->
                        <!--                             />-->
                        <!--                             <img-->
                        <!--                               v-else-->
                        <!--                               src="../../../../../assets/images/pages/gala/right-arrow-grey.svg"-->
                        <!--                               class="cursor-pointer mt-12 ml-12"-->
                        <!--                               width="45px"-->
                        <!--                               style="float:right;"-->
                        <!--                               height="auto"-->
                        <!--                             />-->
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          id="ChooseCharacter"
          class="step"
          :class="isUserLoggedIn &&  (galaAvatarCheck || avtarValue) ? 'status-1' : 'status-0'"
        >
          <div class="flex">
            <div class="line" ></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_1.svg"
              :class="isUserLoggedIn ? 'active' : 'inactive'"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="isUserLoggedIn && autoLoginToken" />-->
          </div>
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/1 p-3 mt-12">
              <vx-card
                :class="isUserLoggedIn ? 'active' : 'inactive'"
                style="border: none; border-radius: 12px"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-start text-left w-full md:w-12/12">
                    <vs-row>
                      <vs-col vs-lg="1">
                        <div
                          class="card-image"
                          v-if="
                            avtarValue === 'Monk' || galaAvatarCheck === 'Monk'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Monk.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Cleric' ||
                            galaAvatarCheck === 'Cleric'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Cleric.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Rogue' ||
                            galaAvatarCheck === 'Rogue'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Rogue.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Ranger' ||
                            galaAvatarCheck === 'Ranger'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Ranger.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Wizard' ||
                            galaAvatarCheck === 'Wizard'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Wizard.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Paladin' ||
                            galaAvatarCheck === 'Paladin'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Paladin.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Bard' || galaAvatarCheck === 'Bard'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Bard.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Barbarian' ||
                            galaAvatarCheck === 'Barbarian'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Barbarian.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div
                          class="card-image"
                          v-else-if="
                            avtarValue === 'Druid' ||
                            galaAvatarCheck === 'Druid'
                          "
                        >
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/gala-images/Avatar/Druid.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div class="card-image" v-else>
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../../src/assets/images/gala-images/logo_branded/Avatar_color.svg"
                            width="52px"
                            height="52px"
                          />
                          <img
                            v-else
                            src="../../../../../../src/assets/images/gala-images/logo_branded/Avatar.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </vs-col>
                      <vs-col vs-lg="8">
                        <div class="text-left">
                          <p class="path-heading mb-2" style="color: #67d8f3">
                            Let’s start bulding your character profile
                          </p>
                          <h5
                            class="mb-2"
                            style="color: #626262"
                            v-if="avtarValue"
                          >
                            Choose your avatar {{ avtarValue }}
                          </h5>
                          <h5 class="mb-2" style="color: #626262" v-else>
                            Choose your avatar {{ galaAvatarCheck }}
                          </h5>
                          <p class="path-long-description">
                            Choose the avatar that you feel more comfortable
                            with to learn and develop at the Galaverse
                          </p>
                        </div>
                      </vs-col>
                      <vs-col vs-lg="3">
                        <img
                          v-if="isUserLoggedIn && !disbaleGrid"
                          src="../../../../../../src/assets/images/gala-images/logo_branded/editIcon.svg"
                          width="52px"
                          height="52px"
                          class="mt-4 mr-12"
                          style="float: right"
                          @click="gridShow"
                        />
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex items-start text-left w-full md:w-12/12">
                    <vs-row>
                      <vs-col class="p-4" vs-lg="12" vs-sm="12" vs-xs="12">
                        <div class="cards island p-4" v-if="disbaleGrid">
                          <vs-row>
                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Monk'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Monk')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Monk.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Monk
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Cleric'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Cleric')"
                                title=""
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Cleric.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Cleric
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Rogue'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Rogue')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Rogue.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Rogue
                                  </h5>
                                </div>
                              </div>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Monk'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Monk.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Monk')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Cleric'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row mb-4">
                                  <vs-col
                                    class="px-6 items-center mb-6"
                                    vs-lg="2"
                                  >
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Cleric.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Cleric')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Rogue'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Rogue.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Rogue')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                          </vs-row>
                          <vs-row class="mt-0 md:mt-4">
                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Ranger'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Ranger')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Ranger.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Ranger
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Wizard'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Wizard')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Wizard.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Wizard
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Paladin'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Paladin')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Paladin.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Paladin
                                  </h5>
                                </div>
                              </div>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Ranger'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Ranger.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Ranger')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Wizard'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Wizard.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Wizard')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Paladin'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Paladin.png"
                                        style="width: 70px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Paladin')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                          </vs-row>

                          <vs-row class="mt-0 md:mt-4">
                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Bard'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Bard')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Bard.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Bard
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Barbarian'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Barbarian')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Barbarian.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Barbarian
                                  </h5>
                                </div>
                              </div>
                            </vs-col>

                            <vs-col
                              class="px-6"
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0"
                                :class="
                                  avtarValue === 'Druid'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                @click="avtarShow('Druid')"
                              >
                                <img
                                  class="m-4"
                                  src="../../../../../assets/images/gala-images/Avatar/Druid.png"
                                  style="width: 50px"
                                  alt=""
                                  :class="
                                    isUserLoggedIn
                                      ? 'active-image-wrapper'
                                      : 'image-wrapper'
                                  "
                                />
                                <div>
                                  <h5
                                    class="mb-2 font-bold"
                                    :class="
                                      isUserLoggedIn
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                    style="color: #231d4f"
                                  >
                                    Druid
                                  </h5>
                                </div>
                              </div>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Bard'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Bard.png"
                                        style="width: 80px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Bard')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>

                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Barbarian'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Barbarian.png"
                                        style="width: 115px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Barbarian')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                              <vx-card
                                v-if="avtarStatus && avtarValue === 'Druid'"
                                class="mt-2 ml-2 mr-2"
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Druid.png"
                                        style="width: 60px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      {{ avtarDescription }}
                                    </p>
                                  </vs-col>
                                </div>

                                <div>
                                  <vs-button
                                    color="#3f74ba"
                                    @click="openEditor('Druid')"
                                    align="center"
                                    style="float: left"
                                    class="ml-6 mt-4"
                                    >Next</vs-button
                                  >
                                </div>
                              </vx-card>
                            </vs-col>
                          </vs-row>
                          <!--                          <vx-card v-if="avtarStatus" class="mt-4" style="background: #67d8f3;color:white;">-->
                          <!--                             {{avtarDescription}}-->
                          <!--                          </vx-card>-->
                          <!-- <img src="@/assets/images/pages/gala/card-arrow.svg" alt="" /> -->
                        </div>
                        <div class="cards island p-4" v-else>
                          <vs-row>
                            <vs-col
                              class="px-6"
                              vs-lg="12"
                              vs-sm="12"
                              vs-xs="12"
                            >
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-if="
                                  galaAvatarCheck === 'Monk' ||
                                  avtarValue === 'Monk'
                                "
                                :class="
                                  galaAvatarCheck === 'Monk' ||
                                  avtarValue === 'Monk'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Monk.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Monks are one with themselves and their
                                      environments. Holding the calmest of
                                      resolves, they are motivated by rational
                                      frames of thought grounded in principle,
                                      purpose, and self-motivated discipline.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Monk')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Cleric' ||
                                  avtarValue === 'Cleric'
                                "
                                :class="
                                  galaAvatarCheck === 'Cleric' ||
                                  avtarValue === 'Cleric'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Cleric.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Clerics are those who seek to bolster the
                                      ability and spirits of others when at
                                      their lowest points and are willing to
                                      give their all for their teams. Generous,
                                      caring, and motivated by interpersonal
                                      devotion, they stand for supporting all
                                      those around them.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Cleric')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Rogue' ||
                                  avtarValue === 'Rogue'
                                "
                                :class="
                                  galaAvatarCheck === 'Rogue' ||
                                  avtarValue === 'Rogue'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Rogue.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      – Rogues are those who are most driven by
                                      success. Pragmatic and constantly
                                      adapting, rogues focus on their outcomes
                                      and achieve them by any means necessary,
                                      whether slinking in the shadows or
                                      striking with extreme precision– Rogues
                                      are those who are most driven by success.
                                      Pragmatic and constantly adapting, rogues
                                      focus on their outcomes and achieve them
                                      by any means necessary, whether slinking
                                      in the shadows or striking with extreme
                                      precision.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Rogue')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Ranger' ||
                                  avtarValue === 'Ranger'
                                "
                                :class="
                                  galaAvatarCheck === 'Ranger' ||
                                  avtarValue === 'Ranger'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Ranger.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Rangers are those who find themselves
                                      solving their problems, often embarking on
                                      independent paths that only they can
                                      understand. Withdrawn in the multitudes of
                                      their minds, they may find it easiest to
                                      work alone, constantly emerging from their
                                      exploration with discovery.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Ranger')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Wizard' ||
                                  avtarValue === 'Wizard'
                                "
                                :class="
                                  galaAvatarCheck === 'Wizard' ||
                                  avtarValue === 'Wizard'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Wizard.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Wizards are the innovators that spin
                                      magical realities out of their intensely
                                      cerebral imaginations. Perceptive
                                      investigators who yearn for understanding
                                      never set a project down until their
                                      curiosities are satisfied.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Wizard')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Paladin' ||
                                  avtarValue === 'Paladin'
                                "
                                :class="
                                  galaAvatarCheck === 'Paladin' ||
                                  avtarValue === 'Paladin'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Paladin.png"
                                        style="width: 72px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Paladins are committed to their goals,
                                      holding promises as sacred oaths they will
                                      see to the end. Thriving in engaged and
                                      responsible teams and suspicious of those
                                      who would seek to challenge authority,
                                      paladins stand as stalwart defenders of
                                      their allies in the face of risk or
                                      recovery.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Paladin')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Bard' ||
                                  avtarValue === 'Bard'
                                "
                                :class="
                                  galaAvatarCheck === 'Bard' ||
                                  avtarValue === 'Bard'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Bard.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Bards are the connectors of communities.
                                      Able to wax eloquent with spontaneity,
                                      these versatile thinkers keep themselves
                                      busy interacting with others. Whether the
                                      storyteller or the story's protagonist,
                                      Bards hold the attention in the room.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Bard')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Barbarian' ||
                                  avtarValue === 'Barbarian'
                                "
                                :class="
                                  galaAvatarCheck === 'Barbarian' ||
                                  avtarValue === 'Barbarian'
                                    ? 'active-avatar'
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Barbarian.png"
                                        style="width: 85px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Barbarians hold confidence that stands
                                      unshaken in the face of adversity. Having
                                      courage and conviction under fire, these
                                      decisive individuals hold no fear in
                                      confrontation and often see their mighty
                                      willpower as a driving force in their
                                      lives.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Barbarian')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                              <div
                                class="vx-row textbox my-2 md:my-0 mt-2 ml-2 mr-2"
                                v-else-if="
                                  galaAvatarCheck === 'Druid' ||
                                  avtarValue === 'Druid'
                                "
                                :class="
                                  galaAvatarCheck === 'Druid' ||
                                  avtarValue === 'Paladin'
                                    ? Druid
                                    : 'inactive-avatar'
                                "
                                style="
                                  background: #67d8f3;
                                  color: white;
                                  width: 98.5%;
                                  border: none;
                                  border-radius: 4px;
                                "
                              >
                                <div class="row m-4">
                                  <vs-col class="items-center mb-6" vs-lg="2">
                                    <div
                                      style="
                                        width: 100px;
                                        height: 120px;
                                        border-radius: 5px;
                                      "
                                    >
                                      <img
                                        class="m-4"
                                        src="../../../../../assets/images/gala-images/Avatar/img/Druid.png"
                                        style="width: 60px"
                                        alt=""
                                        :class="
                                          isUserLoggedIn
                                            ? 'active-image-wrapper'
                                            : 'image-wrapper'
                                        "
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col class="px-6" vs-lg="10">
                                    <p style="color: white" class="mt-4">
                                      Druids seek nothing more than the balance
                                      in the world. Working to establish
                                      fairness in their communities, Druids are
                                      the shepherds leading us into a more
                                      receptive, agreeable, and peaceful way of
                                      living.
                                    </p>
                                    <vs-button
                                      color="#3f74ba"
                                      @click="openEditor('Druid')"
                                      align="center"
                                      style="float: left"
                                      class="mt-4"
                                      >Next</vs-button
                                    >
                                  </vs-col>
                                </div>
                              </div>
                            </vs-col>
                          </vs-row>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          id="ChooseAbilities"
          class="step"
          :class="isUserLoggedIn &&  (galaAvatarCheck || avtarValue)  ? 'status-1' : 'status-0'"
        >
          <div class="flex">
            <div class="line"></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_2.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="isUserLoggedIn && autoLoginToken" />-->
          </div>
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/1 p-3 mt-12">
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  (userProgress === 0 || userProgress > 0)
                    ? 'active'
                    : 'inactive'
                "
              >
                <vs-collapse-item icon-arrow="none">
                  <div slot="header">
                    <div class="flex justify-between items-center">
                      <div class="flex flex-wrap w-11/12">
                        <div class="card-image">
                          <img
                            v-if="
                              isUserLoggedIn &&
                              (galaAvatarCheck || avtarValue) &&
                              (userProgress === 0 || userProgress > 0)
                            "
                            src="../../../../../assets/images/gala-images/logo_branded/skill_develop.svg"
                            width="52px"
                            height="52px"
                          />

                          <img
                            v-else
                            src="../../../../../assets/images/gala-images/logo_branded/Skills.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div class="text-left w-4/5 md:w-0">
                          <p class="path-heading mb-2" style="color: #67d8f3">
                            Add abilities to your character to play your role at
                            GALA
                          </p>
                          <h5 class="mb-2" style="color: #626262">
                            Rank your abilities from best to least known
                          </h5>
                          <p class="path-long-description">
                            A 360 assessment that helps you map your strengths
                            and development areas
                          </p>
                        </div>
                        <div style="float: right">
                          <vs-collapse
                            accordion
                            v-if="
                              isUserLoggedIn &&
                              (galaAvatarCheck || avtarValue) &&
                              (userProgress === 0 || userProgress > 0)
                            "
                          >
                          </vs-collapse>
                        </div>
                      </div>
                      <div class="card-action w-1/12">
                        <img
                          v-if="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            (userProgress === 0 || userProgress > 0)
                          "
                          src="../../../../../assets/images/gala-images/logo_branded/arrow_down.svg"
                          width="45px"
                          class="cursor-pointer"
                          height="auto"
                        />
                        <img
                          v-else
                          src="../../../../../assets/images/gala-images/logo_branded/arrow_down_grey.svg"
                          width="45px"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                  <galaPersonality
                    v-if="
                      isUserLoggedIn &&
                      (galaAvatarCheck || avtarValue) &&
                      (userProgress === 0 || userProgress > 0)
                    "
                    class="mt-12"
                  ></galaPersonality>
                </vs-collapse-item>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          id="Guardians-TalentReport"
          class="step"
          :class="
            isUserLoggedIn &&
            (galaAvatarCheck || avtarValue) &&
            activateCompetency
              ? 'status-1'
              : 'status-0'
          "
        >
          <div class="flex">
            <div class="line"></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_3.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="activateFeedback" />-->
          </div>
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/2 p-3 mt-12" v-if="boardSlug">
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateFeedback
                    ? 'active'
                    : 'inactive'
                "
              >
                <div class="flex justify-between items-center">
                  <div class="flex flex-wrap items-center justify-between">
                    <div class="card-image">
                      <img
                        v-if="
                          isUserLoggedIn &&
                          (galaAvatarCheck || avtarValue) &&
                          activateFeedback
                        "
                        src="../../../../../assets/images/gala-images/logo_branded/My_Feedback.svg"
                        width="52px"
                        height="52px"
                      />
                      <img
                        v-else
                        src="../../../../../assets/images/pages/gala/feedback.svg"
                        width="52px"
                        height="52px"
                      />
                    </div>
                    <div class="text-left">
                      <p class="path-heading mb-2" style="color: #67d8f3">
                        My Feedback
                      </p>
                      <h5 class="mb-2" style="color: #626262">
                        Manage my Guardians
                      </h5>
                      <p class="path-long-description" style="font-size: 12px">
                        To know how other people see me
                      </p>
                    </div>
                  </div>
                  <div class="card-action w-1/12">
                    <img
                      v-if="
                        isUserLoggedIn &&
                        (galaAvatarCheck || avtarValue) &&
                        activateFeedback
                      "
                      src="../../../../../assets/images/icons/gala/right-arrow-blue.svg"
                      width="45px"
                      class="cursor-pointer"
                      height="auto"
                      @click="showFeedbackPopup"
                    />
                    <img
                      v-else
                      src="../../../../../assets/images/pages/gala/right-arrow-grey.svg"
                      width="45px"
                      height="auto"
                    />
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="w-full md:w-1/2 p-3 mt-12" v-else>
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateFeedback
                    ? 'active'
                    : 'inactive'
                "
              >
                <div class="flex justify-between items-center">
                  <div class="flex flex-wrap items-center justify-between">
                    <div class="card-image">
                      <img
                        v-if="
                          isUserLoggedIn &&
                          (galaAvatarCheck || avtarValue) &&
                          activateFeedback
                        "
                        src="../../../../../assets/images/gala-images/logo_branded/My_Feedback.svg"
                        width="52px"
                        height="52px"
                      />
                      <img
                        v-else
                        src="../../../../../assets/images/pages/gala/feedback.svg"
                        width="52px"
                        height="52px"
                      />
                    </div>
                    <div class="text-left">
                      <p class="path-heading mb-2" style="color: #67d8f3">
                        My Feedback
                      </p>
                      <h5 class="mb-2" style="color: #626262">
                        Manage my Guardians
                      </h5>
                      <p class="path-long-description" style="font-size: 12px">
                        To know how other people see me
                      </p>
                    </div>
                  </div>
                  <div class="card-action w-1/12">
                    <img
                      v-if="
                        isUserLoggedIn &&
                        (galaAvatarCheck || avtarValue) &&
                        activateFeedback
                      "
                      src="../../../../../assets/images/icons/gala/right-arrow-blue.svg"
                      width="45px"
                      class="cursor-pointer"
                      height="auto"
                      @click="showFeedbackPopup"
                    />
                    <img
                      v-else
                      src="../../../../../assets/images/pages/gala/right-arrow-grey.svg"
                      width="45px"
                      height="auto"
                    />
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="w-full md:w-1/2 p-3 mt-12">
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateCompetency
                    ? 'active'
                    : 'inactive'
                "
              >
                <div class="flex justify-between items-center">
                  <div class="flex flex-wrap items-center justify-between">
                    <div class="card-image">
                      <img
                        v-if="
                          isUserLoggedIn &&
                          (galaAvatarCheck || avtarValue) &&
                          activateCompetency
                        "
                        src="../../../../../assets/images/gala-images/logo_branded/My_Competencies.svg"
                        width="52px"
                        height="52px"
                      />
                      <img
                        v-else
                        src="../../../../../assets/images/pages/gala/competencies.svg"
                        width="52px"
                        height="52px"
                      />
                    </div>
                    <div class="text-left">
                      <p class="path-heading mb-2" style="color: #67d8f3">
                        My Competencies
                      </p>
                      <h5 class="mb-2" style="color: #626262">
                        View Strength Profile
                      </h5>
                      <p class="path-long-description" style="font-size: 12px">
                        Skill report to view clear strengths and
                      </p>
                      <p class="path-long-description" style="font-size: 12px">
                        possible blind spots.
                      </p>
                    </div>
                  </div>
                  <div class="card-action w-1/12">
                    <img
                      v-if="
                        isUserLoggedIn &&
                        (galaAvatarCheck || avtarValue) &&
                        activateCompetency
                      "
                      src="../../../../../assets/images/icons/gala/right-arrow-blue.svg"
                      width="45px"
                      class="cursor-pointer"
                      height="auto"
                      @click="showCompetencyReport"
                    />
                    <img
                      v-else
                      src="../../../../../assets/images/pages/gala/right-arrow-grey.svg"
                      width="45px"
                      height="auto"
                    />
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          class="step"
          :class="
            isUserLoggedIn &&
            (galaAvatarCheck || avtarValue) &&
            activateCompetency
              ? 'status-1'
              : 'status-0'
          "
        >
          <div class="flex">
            <div class="line"></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_4.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="activateCompetency" />-->
          </div>
          <div>
            <div>
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateCompetency
                    ? 'alex-preferences'
                    : 'inactive'
                "
                class="mt-4"
              >
                <div class="flex flex-wrap items-center justify-between">
                  <div
                    class="flex flex-wrap items-start text-left w-full md:w-6/6"
                  >
                    <div class="md:w-4/4 lg:w-5/5">
                      <h5 class="mb-2 font-bold" style="color: #626262">
                        Join a Guild
                      </h5>
                      <p class="s-head" style="color: #231d4f">
                        Guilds are our communities of adventurers seeking to
                        conquer similar quests on our journey of development and
                        creation. Each of us has our own roles to play in our
                        parties, and in your guild you'll be able to find
                        leaders and peers in your field to help you master what
                        you do.
                      </p>
                      <vs-row>
                        <vs-col class="p-4" vs-lg="12" vs-sm="12" vs-xs="12">
                          <div class="cards island p-4">
                            <vs-row>
                              <vs-col
                                class="px-6"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      1,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/engineering.svg"
                                    style="width: 50px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Tinkerers
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      Engineers / Infrastructure
                                    </p>
                                  </div>
                                </div>
                              </vs-col>

                              <vs-col
                                class="px-6"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox my-2 md:my-0"
                                  @click="
                                    systemActive(
                                      2,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/games.svg"
                                    style="width: 50px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Arcanists
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      Designers / Art / Audio
                                    </p>
                                  </div>
                                </div>
                              </vs-col>

                              <vs-col
                                class="px-6"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox my-2 md:my-0"
                                  @click="
                                    systemActive(
                                      3,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/hafffling.svg"
                                    style="width: 50px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Storytellers
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      Marketing / Narrative
                                    </p>
                                  </div>
                                </div>
                              </vs-col>

                              <vs-col
                                class="px-6 py-4"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      4,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/customer-representative.svg"
                                    style="width: 50px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Acolytes
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      CS / Community Leaders
                                    </p>
                                  </div>
                                </div>
                              </vs-col>

                              <vs-col
                                class="px-6 py-4"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      5,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/leagal.svg"
                                    style="width: 45px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Warlocks
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      Legal
                                    </p>
                                  </div>
                                </div>
                              </vs-col>

                              <vs-col
                                class="px-6 py-4"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      6,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/business-and-finance.svg"
                                    style="width: 50px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Changelings
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      People / Finance / Events
                                    </p>
                                  </div>
                                </div>
                              </vs-col>
                              <vs-col
                                class="px-6 py-4"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      7,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/Oracles_bc.svg"
                                    style="width: 45px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Oracles
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      Directors / Product Managers
                                    </p>
                                  </div>
                                </div>
                              </vs-col>
                              <vs-col
                                class="px-6 py-4"
                                vs-lg="4"
                                vs-sm="12"
                                vs-xs="12"
                              >
                                <div
                                  class="vx-row textbox"
                                  @click="
                                    systemActive(
                                      8,
                                      isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                    )
                                  "
                                  :disabled="
                                    !(
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                    )
                                  "
                                >
                                  <img
                                    class="m-4"
                                    src="../../../../../assets/images/icons/gala/C-suite_bc.svg"
                                    style="width: 45px"
                                    alt=""
                                    :class="
                                      isUserLoggedIn &&
                                      (galaAvatarCheck || avtarValue) &&
                                      activateCompetency
                                        ? 'active-image-wrapper'
                                        : 'image-wrapper'
                                    "
                                  />
                                  <div>
                                    <h5
                                      class="mb-2 font-bold"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                      style="color: #231d4f"
                                    >
                                      Mages
                                    </h5>
                                    <p
                                      style="color: #848199; font-size: 10px"
                                      :class="
                                        isUserLoggedIn &&
                                        (galaAvatarCheck || avtarValue) &&
                                        activateCompetency
                                          ? 'active-image-wrapper'
                                          : 'image-wrapper'
                                      "
                                    >
                                      C-Suite
                                    </p>
                                  </div>
                                </div>
                              </vs-col>
                            </vs-row>

                            <!-- <img src="@/assets/images/pages/gala/card-arrow.svg" alt="" /> -->
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          class="step"
          :class="
            isUserLoggedIn &&
            (galaAvatarCheck || avtarValue) &&
            activateCompetency
              ? 'status-1'
              : 'status-0'
          "
        >
          <div class="flex">
            <div class="line"></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_5.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="isUserLoggedIn" />-->
          </div>
          <div>
            <h1
              class="mb-base text-left mt-2"
              :class="
                isUserLoggedIn &&
                (galaAvatarCheck || avtarValue) &&
                activateCompetency
                  ? 'active-image-wrapper'
                  : 'image-wrapper'
              "
            >
              The code of conduct and culture

              <div class="toggle_radio float-right">
                <input
                  type="radio"
                  class="toggle_option"
                  id="_first_toggle"
                  name="_toggle_option"
                  checked="checked"
                  :disabled="
                    !(
                      isUserLoggedIn &&
                      (galaAvatarCheck || avtarValue) &&
                      activateCompetency
                    )
                  "
                />

                <input
                  type="radio"
                  class="toggle_option"
                  id="_second_toggle"
                  name="_toggle_option"
                  :disabled="
                    !(isUserLoggedIn && galaAvatarCheck && activateCompetency)
                  "
                />

                <label for="_first_toggle" @click="switchData(1)"
                  ><p style="font-size: 14px" class="mt-1">Conduct</p></label
                >
                <label for="_second_toggle" @click="switchData(2)"
                  ><p style="font-size: 14px" class="mt-1">Culture</p></label
                >
                <!--mapped to wip in the code-->
                <div class="toggle_option_slider"></div>
              </div>

              <!--              <vs-switch class="float-right" @change="switchData" v-model="switch1">-->
              <!--                <span slot="on">Conduct</span>-->
              <!--                <span slot="off">Culture</span>-->
              <!--              </vs-switch>-->
            </h1>

            <div
              v-if="
                swicthCondition &&
                isUserLoggedIn &&
                (galaAvatarCheck || avtarValue) &&
                activateCompetency
              "
            >
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateCompetency
                    ? 'alex-preferences'
                    : 'inactive'
                "
              >
                <div class="flex flex-wrap items-center justify-between">
                  <div
                    class="flex flex-wrap items-start justify-center text-left w-full md:w-6/6"
                  >
                    <div class="md:w-4/4 lg:w-5/5">
                      <h5 class="mb-2 font-bold" style="color: #626262">
                        Conduct
                      </h5>
                      <p style="color: #808080">
                        So we expect all adventurers to behave and conduct
                        themselves in a way that is true to our kingdom. We
                        expect all adventurers to adhere to the following
                      </p>
                      <ul class="card-text realm-ul">
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Behave in a respectful, professional and polite manner
                          and ensure their behaviour does not breach the
                          Equality Act 2010.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Cooperate fully with fellow adventurers and High Mages
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Comply with all reasonable management instructions and
                          ensure satisfactory standards of performance are
                          maintained at all times while on this journey.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Understand and follow all company policies and
                          procedures
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
            <div v-else>
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateCompetency
                    ? 'alex-preferences'
                    : 'inactive'
                "
              >
                <div class="flex flex-wrap items-center justify-between">
                  <div
                    class="flex flex-wrap items-start justify-center text-left w-full md:w-6/6"
                  >
                    <div class="md:w-4/4 lg:w-5/5">
                      <h5 class="mb-2 font-bold" style="color: #626262">
                        Culture
                      </h5>
                      <p style="color: #808080">
                        The Gala Games kingdom stands for equality and
                        diversity.
                      </p>
                      <ul class="card-text realm-ul">
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          The Company is committed to being a successful, caring
                          and welcoming place for adventures.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Gala kingdom prides itself as being a supportive and
                          inclusive environment where our adventures can reach
                          their full potential without prejudice and
                          discrimination.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          We are committed to a culture where respect and
                          understanding are fostered, and the diversity of
                          people's backgrounds and circumstances will be
                          positively valued always.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          Equality of opportunity, valuing diversity and
                          compliance with the law is to the benefit of all
                          individuals in our Company as it seeks to develop the
                          skills and abilities of its adventures.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          While specific responsibility for eliminating
                          discrimination and providing equality of opportunity
                          lies with our Mages.
                        </li>
                        <li
                          class="mt-4"
                          style="color: #808080"
                          :class="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                              ? 'active-image-wrapper'
                              : 'image-wrapper'
                          "
                        >
                          All adventurers at all levels have a responsibility to
                          treat others with dignity and respect.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div
          class="step"
          :class="
            isUserLoggedIn &&
            (galaAvatarCheck || avtarValue) &&
            activateCompetency
              ? 'status-1'
              : 'status-0'
          "
        >
          <div class="flex">
            <div class="line"></div>
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_6.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="isUserLoggedIn" />-->
          </div>
          <div>
            <div>
              <vx-card
                :class="
                  isUserLoggedIn &&
                  (galaAvatarCheck || avtarValue) &&
                  activateCompetency
                    ? 'active'
                    : 'inactive'
                "
                style="border: none; border-radius: 12px"
                class="mt-4"
              >
                <div class="flex flex-wrap items-center justify-between">
                  <div
                    class="flex flex-wrap items-start justify-center text-left w-full md:w-5/6"
                  >
                    <div class="md:w-4/4 lg:w-5/5">
                      <p class="s-head"></p>
                      <h5 class="mb-2 font-bold" style="color: #626262">
                        Pledge to the code
                      </h5>
                      <p style="color: #808080">
                        This is how we learned to work effectively together.
                        Keep this secret code in your pocket and don’t forget to
                        send out the code to the team when you’re working. Are
                        you ready? Come closer. Make sure that you are alone.
                      </p>

                      <div
                        v-if="
                          revealTermsStatusCheck === false &&
                          revealTermsStatusFirstTime === false
                        "
                      >
                        <p
                          class="mt-4"
                          v-if="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                          "
                        >
                          <vs-checkbox v-model="revealCoachStatus"
                            >Read the code and confirm your pledge to
                            it.</vs-checkbox
                          >
                        </p>
                        <p
                          class="mt-4 ml-8"
                          v-if="
                            isUserLoggedIn &&
                            (galaAvatarCheck || avtarValue) &&
                            activateCompetency
                          "
                        >
                          <vs-button @click="revealCoachDiv"> Pledge</vs-button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!--                  <div class="w-full md:w-1/6 flex justify-end">-->
                  <!--                    <img-->
                  <!--                      v-if="isUserLoggedIn"-->
                  <!--                      src="../../../../../assets/images/icons/gala/right-arrow-blue.svg"-->
                  <!--                      width="45px"-->
                  <!--                      height="auto"-->
                  <!--                      class="cursor-pointer"-->
                  <!--                    />-->
                  <!--                    <img-->
                  <!--                      v-else-->
                  <!--                      src="../../../../../assets/images/pages/gala/right-arrow-grey.svg"-->
                  <!--                      width="45px"-->
                  <!--                      height="auto"-->
                  <!--                    />-->
                  <!--                  </div>-->
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <!--        <div class="bubble x1"></div>-->
        <!--        <div class="bubble x2"></div>-->
        <!--        <div class="bubble x3"></div>-->
        <!--        <div class="bubble x4"></div>-->
        <!--        <div class="bubble x5"></div>-->
        <!--        <div class="bubble x6"></div>-->
        <!--        <div class="bubble x7"></div>-->
        <!--        <div class="bubble x8"></div>-->
        <!--        <div class="bubble x9"></div>-->
        <!--        <div class="bubble x10"></div>-->
        <!--        <div class="bubble x1"></div>-->
        <!--        <div class="bubble x2"></div>-->
        <!--        <div class="bubble x3"></div>-->
        <!--        <div class="bubble x4"></div>-->
        <!--        <div class="bubble x5"></div>-->
        <!--        <div class="bubble x6"></div>-->
        <!--        <div class="bubble x7"></div>-->
        <!--        <div class="bubble x8"></div>-->
        <!--        <div class="bubble x9"></div>-->
        <!--        <div class="bubble x10"></div>-->
        <div
          class="step"
          :class="
            isUserLoggedIn &&
            (galaAvatarCheck || avtarValue) &&
            activateCompetency
              ? 'status-1'
              : 'status-0'
          "
        >
          <div class="flex">
            <img
              src="../../../../../../src/assets/images/gala-images/circle_num/start_7.svg"
              class="checkpoint-circle"
              width="52px"
              height="52px"
            />
            <!--            <CheckpointCircle :active="isUserLoggedIn" />-->
          </div>
          <div class="w-full md:w-1/1 p-3">
            <vx-card
              style="
                background: linear-gradient(
                  282.82deg,
                  rgba(255, 255, 255, 0) 35.2%,
                  rgb(103, 216, 243) 102.72%
                );
              "
              :class="
                isUserLoggedIn &&
                (galaAvatarCheck || avtarValue) &&
                activateCompetency
                  ? 'active'
                  : 'inactive'
              "
            >
              <div class="flex flex-wrap items-center justify-between">
                <div
                  class="flex items-start text-left w-full"
                  style="padding-bottom: 0px"
                >
                  <div
                    v-if="
                      assignedCoach &&
                      Object.keys(assignedCoach).length &&
                      isUserLoggedIn &&
                      (galaAvatarCheck || avtarValue) &&
                      activateCompetency
                    "
                  >
                    <div>
                      <vs-avatar
                        size="180px"
                        v-if="assignedCoach.profilePictureUrl"
                        :src="
                          constants.s3Bucket +
                          '/editor/profile-pictures/' +
                          assignedCoach.profilePictureUrl
                        "
                        alt=""
                      />
                      <vs-avatar
                        v-else
                        size="180px"
                        
              :src="require('@/assets/images/temp-img/temp-boringavatar.png')"
                        alt="Boring Avatar"
                      />
                    </div>
                    <!-- <img
                      v-else
                      class="mt-12 ml-8"
                      src="../../../../../assets/images/gala-images/logo_branded/coach_lock_grey.svg"
                      alt=""
                    /> -->
                  </div>
                  <div
                    v-else-if="
                      isUserLoggedIn &&
                      (galaAvatarCheck || avtarValue) &&
                      activateCompetency
                    "
                    class="w-1/5 md:"
                  >
                    <img
                      class="mt-12 ml-8"
                      v-if="
                        isUserLoggedIn &&
                        (galaAvatarCheck || avtarValue) &&
                        activateCompetency
                      "
                      src="../../../../../assets/images/gala-images/logo_branded/coach_lock.svg"
                      alt=""
                    />
                  </div>
                  <div v-else class="w-1/5 md:">
                    <img
                      class="mt-12 ml-8"
                      src="../../../../../assets/images/gala-images/logo_branded/coach_lock_grey.svg"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="
                      assignedCoach &&
                      Object.keys(assignedCoach).length &&
                      isUserLoggedIn &&
                      (galaAvatarCheck || avtarValue) &&
                      activateCompetency && ( revealTermsStatusCheck === true ||
                          revealTermsStatusFirstTime === true)
                    "
                    class="ml-5"
                  >
                    <div
                      class="mb-2 mt-2"
                      style="color: #000000; font-size: 25px; font-weight: 100"
                    >
                      <span style="font-weight: 900"
                        >{{ assignedCoach.firstName }}
                        {{ assignedCoach.lastName }}</span
                      >
                      is your Mentor
                    </div>
                    <p class="path-long-description mb-5">
                      <span style="color: #585858">
                        Mentor app helps you add skills to develop with
                        pre-defined and custom progress measures. Your coaching
                        relationship is defined in the app that allows both you
                        and your mentor to continuously work using planned
                        touchpoints.
                      </span>
                    </p>
                    <vs-button @click.stop="redirectToCoach()">
                      Get Started
                    </vs-button>
                  </div>
                  <div v-else class="text-left mt-4 ml-12">
                    <h1
                      class="mb-2 mt-2 md:mt-12 text-3xl md:text-"
                      style="color: #000000"
                    >
                      <b> Reveal my Mentor!</b>
                    </h1>
                    <p class="path-long-description">
                      <span style="color: #585858">
                        Complete your character profile and skill strength
                        assessments to match to your Mentor.
                      </span>
                    </p>
                    <p class="path-long-description">
                      <span style="color: #585858">
                        Join the GALA guidance project to a journey of personal
                        success.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </section>
    <vs-popup
      fullscreen
      :title="$t('alex.competencyReportModalTitle')"
      :active.sync="showCompetencyReportStatus"
    >
      <div style="height: 85vh">
        <iframe
          :src="`https://gala.talentprint.com/profiles/view` + autoLoginToken"
          class="w-full h-full border-0"
          id="reportRefresh"
          :key="userProgress"
        >
        </iframe>
      </div>
    </vs-popup>
    <!--    <vs-popup fullscreen title="Self Assessment" :active.sync="showAssessment">-->
    <!--      <div style="height: 80vh">-->
    <!--        <iframe-->
    <!--          :src="-->
    <!--            `https://gala.talentprint.com/assessments/update/` + autoLoginToken-->
    <!--          "-->
    <!--          id="feedback"-->
    <!--          class="w-full h-full border-0"-->
    <!--        >-->
    <!--        </iframe>-->
    <!--      </div>-->
    <!--    </vs-popup>-->
    <vs-popup fullscreen title="Feedback" :active.sync="showFeedback">
      <div style="height: 80vh">
        <iframe
          :src="
            `https://gala.talentprint.com/users/manage_raters/` + autoLoginToken
          "
          id="feedbackInvite"
          class="w-full h-full border-0"
          :key="userProgress"
        >
        </iframe>
      </div>
    </vs-popup>
    <vs-popup fullscreen title="Tutorial" :active.sync="showTutorial">
      <div class="mt-12">
        <div id="loading-bg">
          <div class="loading-logo">
            <!--          <img-->
            <!--            src="<%= BASE_URL %>loader.png"-->
            <!--            alt="Logo"-->
            <!--            width="64px"-->
            <!--            height="64px"-->
            <!--          />-->
          </div>
          <div class="loading">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
          </div>
        </div>

        <!--        <vs-row vs-w="12" style="margin-top:40%;">-->
        <!--          <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-lg="12" vs-sm="4" vs-xs="12" style="color:#44CC88;" >-->
        <!--            <vs-button text-align="center" style="float: right;" color="success">Watch later</vs-button>-->
        <!--            <vs-button text-align="center" style="float: right;" class="ml-4" color="primary">Skip forever</vs-button>-->
        <!--          </vs-col>-->
        <!--        </vs-row>-->
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Library from "./Library";
import galaPersonality from "./personality/Main";
import { PATH_NAMES, MY_PATH } from "@/assets/data/alex";
import MyPathCard from "./MyPathCard";
import CheckpointCircle from "./CheckpointCircle";
import constants from "@/constants";

export default {
  components: {
    Library,
    MyPathCard,
    galaPersonality,
    CheckpointCircle,
  },
  PATH_NAMES,
  MY_PATH,
  data() {
    return {
      showCompetencyReportStatus: false,
      revealCoachStatus: false,
      revealTermsStatusFirstTime: false,
      selectedAvtar: false,
      coachStatus: false,
      avtarImage: false,
      showAssessment: false,
      avtarNotDisabled: false,
      showFeedback: false,
      showTutorial: false,
      avtarStatus: false,
      disbaleGrid: false,
      avtarValue: "",
      avtarDescription: "",
      switch1: true,
      joinLink: "",
      swicthCondition: true,
      userId: "",
      boardSlug: "",
      flag: false,
      profileCheck1: false,
      profileCheck2: false,
      profileCheck3: false,
      profileCheck4: false,
      profileCheck5: false,
      profileCheck6: false,
      profileCheck7: false,
      systemCheck1: false,
      systemCheck2: false,
      systemCheck3: false,
      systemCheck4: false,
      systemCheck5: false,
      systemCheck6: false,
      profileCardPopupActive: false,
      systemCardPopupActive: false,
      pledgePopup: false,
      title: "",
      description: "",
      src: "",
      name: "",
      constants,
    };
  },
  computed: {
    personality() {
      console.log(
        "personality Data",
        this.$store.state.editor.personality.personalityYoulabToken
      );
      return this.$store.state.editor.personality;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    organizationId() {
      console.log(this.$store.state.organization.orgData._id);
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    galaAvatarCheck() {
      return this.$store.state.users.data.galaAvatar;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    revealTermsStatusCheck() {
      if (this.$store.state.users.data.revealTermsStatus) {
        return true;
      } else {
        return false;
      }
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    activatePreferences() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    },
    assignedCoach() {
      return this.$store.state.journey.assignedCoach;
    },
  },
  watch: {
    userProgress() {
      this.$forceUpdate();
    },
    revealTermsStatusCheck() {
      this.$forceUpdate();
    },
    galaAvatarCheck: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
    avtarValue: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
    activateCompetency() {
      this.$forceUpdate();
    },
    usersData() {
      // fetch assigned coach
      this.fetchAssignedCoach();
    },
  },
  methods: {
    showCompetencyReport() {
      this.showCompetencyReportStatus = true;
      document.getElementById("reportRefresh").src =
        document.getElementById("reportRefresh").src;
    },
    showFeedbackPopup() {
      console.log("data");
      this.showFeedback = true;
      document
        .getElementById("feedbackInvite")
        .contentWindow.location.reload(true);
    },
    avtarShow(value) {
      if (value === "Monk") {
        this.avtarValue = value;
        this.avtarStatus = true;
        this.avtarNotDisabled = true;

        this.avtarDescription =
          "Monks are one with themselves and their environments. Holding the calmest of  resolves, they are motivated by rational frames of thought grounded in principle, purpose, and self-motivated discipline.";
      } else if (value === "Cleric") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Clerics are those who seek to bolster the ability and spirits of others when at their lowest points and are willing to give their all for their teams. Generous, caring, and motivated by interpersonal devotion, they stand for supporting all those around them.";
      } else if (value === "Rogue") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Rogues are those who are most driven by success. Pragmatic and constantly adapting, rogues focus on their outcomes and achieve them by any means necessary, whether slinking in the shadows or striking with extreme precision\n";
      } else if (value === "Ranger") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Rangers are those who find themselves solving their problems, often embarking on independent paths that only they can understand. Withdrawn in the multitudes of their minds, they may find it easiest to work alone, constantly emerging from their exploration with discovery. \n";
      } else if (value === "Wizard") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Wizards are the innovators that spin magical realities out of their intensely cerebral imaginations. Perceptive investigators who yearn for understanding never set a project down until their curiosities are satisfied.\n";
      } else if (value === "Paladin") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Paladins are committed to their goals, holding promises as sacred oaths they will see to the end. Thriving in engaged and responsible teams and suspicious of those who would seek to challenge authority, paladins stand as stalwart defenders of their allies in the face of risk or recovery.\n";
      } else if (value === "Bard") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Bards are the connectors of communities. Able to wax eloquent with spontaneity, these versatile thinkers keep themselves busy interacting with others. Whether the storyteller or the story's protagonist, Bards hold the attention in the room. ";
      } else if (value === "Barbarian") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Barbarians hold confidence that stands unshaken in the face of adversity. Having courage and conviction under fire, these decisive individuals hold no fear in confrontation and often see their mighty willpower as a driving force in their lives.\n";
      } else if (value === "Druid") {
        this.avtarValue = value;
        this.avtarStatus = true;

        this.avtarDescription =
          "Druids seek nothing more than the balance in the world. Working to establish fairness in their communities, Druids are the shepherds leading us into a more receptive, agreeable, and peaceful way of living. \n";
      }
      console.log("value", value);
    },
    switchData(value) {
      if (value === 2) {
        this.swicthCondition = false;
      } else if (value == 1) {
        this.swicthCondition = true;
      }
    },
    gridShow() {
      this.disbaleGrid = true;
    },
    openEditor(value) {
      this.avtarImage = true;
      this.flag = true;
      this.selectedAvtar = true;
      this.avtarValue = value;
      this.disbaleGrid = false;
      document.getElementById("editorGala").contentWindow.location.reload(true);
      const galaAvatar = {
        userId: this.usersData._id,
        galaAvatar: this.avtarValue,
      };
      this.$store.dispatch("users/updateGalaAvtar", galaAvatar).catch((err) => {
        throw err;
      });
      // console.log('this.avtarValue',galaAvatar);
    },
    revealCoachDiv() {
      if (this.revealCoachStatus === true) {
        this.pledgePopup = true;
        this.coachStatus = true;

        if(this.assignedCoach && this.assignedCoach._id){
          this.$store.dispatch('boards/revealCoach', {
            _id:this.assignedCoach._id,
            gtbrddUserId:this.usersData._id,
            traineeEmail: this.usersData.email,
            coachEmail:  this.assignedCoach.email,
            mentorAssigned: true,
            gtbrddOrganizationId: this.orgData._id,
            traineePledged:true
          }).then((res) => {
            console.log(' mentor assign', res.data);
            this.$vs.loading.close();
            const update = {
              userId: this.usersData._id,
              revealTermsStatus: true,
              firstName: this.usersData.firstName,
              lastName: this.usersData.lastName,
              email: this.usersData.email,
              traineePledged:true
            };
            this.$store
              .dispatch("users/revealTermsUpdate", update)
              .then((revealTerms) => {
                console.log("revealTermsUpdate", revealTerms.revealTermsStatus);
                this.revealTermsStatusFirstTime = revealTerms.revealTermsStatus;
              })
              .catch((err) => {
                throw err;
              });
          }).catch(() => {
            this.$vs.loading.close();
          });

        }
        else{
          const update = {
            userId: this.usersData._id,
            revealTermsStatus: true,
            flag: "pledgeEmailSent",
            mentorAssigned: false,
            firstName: this.usersData.firstName,
            lastName: this.usersData.lastName,
            email: this.usersData.email,
          };
          this.$store
            .dispatch("users/revealTermsUpdate", update)
            .then((revealTerms) => {
              this.$vs.loading.close();
              this.revealTermsStatusFirstTime = revealTerms.revealTermsStatus;
            })
            .catch((err) => {
              throw err;
            });
        // }

      }
      }
     else {
        this.revealCoachStatus = false;
      }

      // fetch assigned coach
      this.fetchAssignedCoach();

      // console.log('this.avtarValue',revealData);
    },
    getUserDataById(userId) {
      return this.currentBoardUsers.find(user => { return userId == user.userId; });
    },
    profileActive(value, profileActive) {
      if (profileActive === false) {
        this.profileCardPopupActive = false;
      } else {
        this.profileCardPopupActive = true;
      }
      if (value === 1) {
        this.title = "HIGH MAGE 1";
        this.name = "Eric Schiermeyer";
        this.description =
          "Eric Schiermeyer specializes in the magic of management.";
        this.src = "/img/mage-tower-image.c1009a0c.png";
        this.profileCheck1 = true;
      } else if (value === 2) {
        this.title = "HIGH MAGE 2";
        this.name = "Wright Thurston";
        this.description =
          "Wright Thurston has been nurturing and experimenting with the possibilities of blockchain technology.";
        this.src = "/img/mage-tower-image2.3ba59ee2.png";
        this.profileCheck2 = true;
      } else if (value === 3) {
        this.title = "HIGH MAGE 3";
        this.name = "John Oswald";
        this.description =
          "John Oswald is the mastermind behind the crafting of the potions that have captured the minds and attention of gamers worldwide.";
        this.src = "/img/mage-tower-image3.6efff994.png";
        this.profileCheck3 = true;
      } else if (value === 4) {
        this.title = "HIGH MAGE 4";
        this.name = "Adam Price";
        this.description =
          "Adam Price is the Mage of Engineering, who possesses the power to will things into existence with only his mind. ";
        this.src = "/img/mage-tower-image.c1009a0c.png";
        this.profileCheck4 = true;
      } else if (value === 5) {
        this.title = "HIGH MAGE 5";
        this.name = "Jason Brink";
        this.description =
          "Jason Brink is the master of spells; his words can sway your thoughts and leave you asking for more of his sweet whisper.";
        this.src = "/img/mage-tower-image5.e31e6708.png";
        this.profileCheck5 = true;
      } else if (value === 6) {
        this.title = "HIGH MAGE 6";
        this.name = "James Olden";
        this.description =
          "Our sixth High Mage is James Olden, the Mage of Strategy, whose secret power lies in orchestrating deals and treatises to expand Gala Games influences. ";
        this.src = "/img/mage-tower-image6.9f62a383.png";
        this.profileCheck6 = true;
      } else if (value === 7) {
        this.title = "HIGH MAGE 7";
        this.name = "Sarah Buxton";
        this.description =
          "The last of the Seven High Mages is Sarah Buxton, the Master of Operation. No matter the size of the boulder or how high the obstacle is in your way, Sarah will use her secret magic and create a tunnel for your team to pass through. ";
        this.src = "/img/mage-tower-image4.b4d95e31.png";
        this.profileCheck7 = true;
      }
    },
    systemActive(value, systemActiveStaus) {
      if (systemActiveStaus === undefined || systemActiveStaus === false) {
        this.systemCardPopupActive = false;
      } else {
        this.systemCardPopupActive = true;
      }
      if (value === 1) {
        this.title = "Engineers / Infrastructure";
        this.description =
          "Tinkerers are our crafters, cranking the gears of the superb structure upon which we will all strive to greatness. They are always busy but very approachable, dwelling between the lines of code and ensure that all programs work perfectly.";
        this.src = "@assets/images/icons/gala/engineering.svg";
        this.joinLink =
          "https://getboarded.tech/board/invite/engineering-dl9nlb12sf";
        this.systemCheck1 = true;
      } else if (value === 2) {
        this.title = "Designers / Art / Audio";
        this.description =
          "While Galaxians of all guilds demonstrate unique creativity in their prowess, Arcanists are those who bring their inspired thoughts to a manifested reality. Giving color and sound to our world, Arcanists bring forward vibrant conjurations of the visions we hold.";
        this.systemCheck2 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/game-designers-x8miw0dx6";
      } else if (value === 3) {
        this.title = "Marketing / Narrative";
        this.description =
          "Galaxians all have a legacy to leave behind, and our Storytellers are the ones who help spread our tales throughout the lands. Weaving words through worlds, our Storytellers bring our glory to light.";
        this.systemCheck3 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/marketing-bj07w3b0ei";
      } else if (value === 4) {
        this.title = "CS / Community Leaders";
        this.description =
          "Gala's Acolytes stand to be our first response to any community trouble. When Gala, a Galaxian, or one of our community members is hurt, our Acolytes will be there with the power to remedy their issue. The culture of Gala is sustained and secured through their devotion to the people.";
        this.systemCheck4 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/customer-service-dg7c2b94r";
      } else if (value === 5) {
        this.title = "Legal";
        this.description =
          "Warlocks are those who use the written word as their power. With magic fuelled by law, their tomes hold interplanar contracts and rituals of truth binding. Their wards of protection keep disaster that would threaten Galaxia at bay.";
        this.systemCheck5 = true;
        this.joinLink = "https://getboarded.tech/board/invite/legal-pvtqz4m3w";
      } else if (value === 6) {
        this.title = "People / Finance / Events";
        this.description =
          "Changelings are always adapting to support the needs of their teams in whatever way is best. These shapeshifters set the stage for all of Gala to succeed, encouraging change in not only themselves, but everyone around them.";
        this.systemCheck6 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/hr--finance-lt8tpaorl";
      } else if (value === 7) {
        this.title = "Directors / Product Managers";
        this.description =
          "The Oracles are those who have a vision for Galaxians and see that through. With the guidance of the Oracles our teams will flourish in their adventure, set on their path by prophecies set forth by these seers.";
        this.systemCheck6 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/directorsproduct-managers-os524rxvt";
      } else if (value === 8) {
        this.title = "C-Suite";
        this.description =
          "The Mage Tower is our group of sages whose wisdom guides all of Galaxia. The Keepers of truth, these mystics have pledged to lead their ranks to ascendancy. Reality holds no limits for the inventive magic of The Mage Tower.";
        this.systemCheck6 = true;
        this.joinLink =
          "https://getboarded.tech/board/invite/c-suite-6w2i8n0aqj";
      }
      console.log("hello");
    },
    redirectToCoach() {
      const userSlug =
        this.usersData.email && this.usersData.email
          ? this.usersData.email.split("@")[0]
          : "";
      if (userSlug) {
        window.location.href = `${constants.coachServiceUrl}/oauth?selectedAccount=${userSlug}`;
      } else {
        window.location.href = `${constants.coachServiceUrl}/oauth`;
      }
    },
    fetchAssignedCoach() {
      if (this.usersData && this.usersData._id) {
        this.$vs.loading();
        this.$store
          .dispatch("journey/fetchAssignedCoach", {
            userId: this.usersData._id,
          })
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    anchorHashCheck() {
      const elementId = this.$route.hash.replace("#", "");

      const loadElement = setInterval(function () {
        if (elementId) {
          let elementPosition = document
            .getElementById(elementId)
            .getBoundingClientRect().top;
          let headerOffset = 150;
          let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });
        }
      }, 1000);

      setTimeout(() => {
        clearInterval(loadElement);
      }, 3000);
    },
  },
  mounted() {
    this.anchorHashCheck();
  },
  created() {
    setTimeout(this.anchorHashCheck(), 5000);
    let url = this.$route.path.split("/");

    this.boardSlug = url[2];
    this.userId = url[3];
    const orgSlug = url[1];

    if (orgSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", orgSlug)
        .then((res) => {
          console.log("res.data", res.data.data[0]);
          this.organizationSlug = res.data.data[0].slug;
          this.organizationName = res.data.data[0].name;
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.$store.dispatch("journey/fetchUserSegments", {
              orgId: res.data.data[0]._id,
            });
          }
        })
        .catch((err) => {
          throw err;
        });
    }

    // fetch assigned coach
    this.fetchAssignedCoach();

    // this.$store
    //   .dispatch("boards/fetchUserBoardData",this.userId )
    //   .then((res) => {
    //
    //     // this.$store.commit(
    //     //   "boards/SET_USER_BOARD_DATA",
    //     //   res.data
    //     // );
    //     // console.log('res.data',res.data);
    //
    //   })
    //   .catch((err) => {
    //     throw err;
    //   });
  },
};
</script>
<style scoped>
.circle {
  border-radius: 50%;
  background-color: deepskyblue;
  width: 52px;
  height: 52px;
  position: absolute;
  opacity: 0;
  animation: scaleIn 4s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
}

@keyframes scaleIn {
  from {
    transform: scale(0.5, 0.5);
    opacity: 0.5;
  }
  to {
    transform: scale(2.5, 2.5);
    opacity: 0;
  }
}
p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
h1 {
  color: #231d4f;
  font-weight: 400;
}

section {
  padding-top: 8rem;
}

.alex-preferences p,
.alex-preferences h5 {
  color: #f29300;
}

.s-head {
  margin-bottom: 0.2rem;
}

.active p.s-head {
  color: #f29300;
}
.step-headline.active,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.step-headline.inactive {
  color: #ccc !important;
}
.step {
  position: relative;
  display: flex;
}

.step:not(:last-child) {
  padding-bottom: 6rem;
}
.step:last-child {
  padding-bottom: 12rem;
}
.step > div:first-child img {
  z-index: 1;
  background: #fff;
  border-radius: 50%;
}
.line {
  position: absolute;
  left: 25px;
  top: 0px;
  bottom: 0px;
}
.line:only-child {
  top: 30px;
  bottom: 4px;
}
.step-1 {
  bottom: 4px;
}
.step.status-0 > div:first-child >>> .line {
  border-left: 6px solid #d0cfcf;
}
.step.status-1 > div:first-child >>> .line {
  border-left: 6px solid #3089f0;
  border-color: #3b39f5;
}
.step > div:first-child {
  margin-right: 2%;
}
.textbox {
  background: #ffffff;
  border: 1px solid #efedf8;
  align-items: center;
  border-radius: 4px;
}
.margin-fix {
  margin: -3rem -0.75rem 0 -0.75rem;
}
.realm-ul > li::before {
  content: url("../../../../../assets/images/pages/gala/li-before.png");
  margin-right: 4px;
}
.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  opacity: 0.2;
}
.active-image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  opacity: 1;
}
.editor-iframe {
  width: 100%;
  height: calc(100vh);
}
.toggle_radio {
  position: relative;
  background: radial-gradient(
      18.95% 15.16% at 29.81% 21.98%,
      rgba(255, 255, 255, 0.6) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #3280fc; /*rgba(255,255,255,.1)*/
  margin: 4px auto;
  overflow: hidden;
  padding: 0 !important;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  height: 36px;
  width: /*318px;*/ 220px;
}
.toggle_radio > * {
  float: left;
}
.toggle_radio input[type="radio"] {
  display: none;
  /*position: fixed;*/
}
.toggle_radio label {
  font: 90%/1.618 Montserrat, Helvetica, Arial, sans-serif;
  color: rgba(255, 255, 255, 0.9);
  z-index: 0;
  display: block;
  width: /*100px;*/ 110px;
  height: 30px;

  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1;
  /*background: rgba(0,0,0,.1);*/
  text-align: center;
  /*margin: 0 2px;*/
  /*background: blue;*/ /*make it blue*/
}
.toggle_radio label p {
  padding: 3px;
}
.toggle_option_slider {
  /*display: none;*/
  /*background: red;*/
  width: /*100px;*/ 110px;
  height: 30px;
  position: absolute;
  top: 3px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

input[id$="_first_toggle"]:checked ~ .toggle_option_slider {
  background: rgba(255, 255, 255, 0.3);
  left: 3px;
}
input[id$="_second_toggle"]:checked ~ .toggle_option_slider {
  background: rgba(255, 255, 255, 0.3);
  left: /*109px*/ 115px;
}
input[id$="_third_toggle"]:checked ~ .toggle_option_slider {
  background: rgba(255, 255, 255, 0.3);
  left: /*215px;*/ 135px;
}
@media screen and (max-width: 500px) {
  .margin-fix {
    margin: -0.75rem;
  }
  .step > div:first-child img {
    height: 40px;
    width: 40px;
  }
  .line {
    left: 19px;
  }
}

p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
.inactive div.card-image {
  background-color: #ffffff !important;
}
.active div.card-image {
  background-color: #ffffff;
}

.card-image {
  margin-right: 1.25rem;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.s-head {
  margin-bottom: 0.2rem;
}
.active-avatar {
  background: #67d8f3;
}
.inactive-avatar {
  background: ;
}
.active p.path-heading {
  color: #f29300;
}

.active h5 {
  color: #231d4f;
}
.active p.path-long-description {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.vx-card.inactive {
  border-radius: 12px;
  border: none;
}
#background-wrap {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: -1;
}

/* KEYFRAMES */

@-webkit-keyframes animateBubble {
  0% {
    margin-top: 1000px;
  }
  100% {
    margin-top: -100%;
  }
}

@-moz-keyframes animateBubble {
  0% {
    margin-top: 1000px;
  }
  100% {
    margin-top: -100%;
  }
}

@keyframes animateBubble {
  0% {
    margin-top: 1000px;
  }
  100% {
    margin-top: -100%;
  }
}

@-webkit-keyframes sideWays {
  0% {
    margin-left: 0px;
  }
  100% {
    margin-left: 50px;
  }
}

@-moz-keyframes sideWays {
  0% {
    margin-left: 0px;
  }
  100% {
    margin-left: 50px;
  }
}

@keyframes sideWays {
  0% {
    margin-left: 0px;
  }
  100% {
    margin-left: 50px;
  }
}

/* ANIMATIONS */

.x1 {
  -webkit-animation: animateBubble 25s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  -moz-animation: animateBubble 25s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  animation: animateBubble 25s linear infinite,
    sideWays 2s ease-in-out infinite alternate;

  left: -5%;
  top: 5%;

  -webkit-transform: scale(0.6);
  -moz-transform: scale(0.6);
  transform: scale(0.6);
}

.x2 {
  -webkit-animation: animateBubble 20s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  -moz-animation: animateBubble 20s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  animation: animateBubble 20s linear infinite,
    sideWays 4s ease-in-out infinite alternate;

  left: 5%;
  top: 80%;

  -webkit-transform: scale(0.4);
  -moz-transform: scale(0.4);
  transform: scale(0.4);
}

.x3 {
  -webkit-animation: animateBubble 28s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  -moz-animation: animateBubble 28s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  animation: animateBubble 28s linear infinite,
    sideWays 2s ease-in-out infinite alternate;

  left: 10%;
  top: 40%;

  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  transform: scale(0.7);
}

.x4 {
  -webkit-animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;
  -moz-animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;
  animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;

  left: 20%;
  top: 0;

  -webkit-transform: scale(0.3);
  -moz-transform: scale(0.3);
  transform: scale(0.3);
}

.x5 {
  -webkit-animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  -moz-animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;

  left: 30%;
  top: 50%;

  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  transform: scale(0.5);
}

.x6 {
  -webkit-animation: animateBubble 21s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  -moz-animation: animateBubble 21s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  animation: animateBubble 21s linear infinite,
    sideWays 2s ease-in-out infinite alternate;

  left: 50%;
  top: 0;

  -webkit-transform: scale(0.8);
  -moz-transform: scale(0.8);
  transform: scale(0.8);
}

.x7 {
  -webkit-animation: animateBubble 20s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  -moz-animation: animateBubble 20s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  animation: animateBubble 20s linear infinite,
    sideWays 2s ease-in-out infinite alternate;

  left: 65%;
  top: 70%;

  -webkit-transform: scale(0.4);
  -moz-transform: scale(0.4);
  transform: scale(0.4);
}

.x8 {
  -webkit-animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;
  -moz-animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;
  animation: animateBubble 22s linear infinite,
    sideWays 3s ease-in-out infinite alternate;

  left: 80%;
  top: 10%;

  -webkit-transform: scale(0.3);
  -moz-transform: scale(0.3);
  transform: scale(0.3);
}

.x9 {
  -webkit-animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  -moz-animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;
  animation: animateBubble 29s linear infinite,
    sideWays 4s ease-in-out infinite alternate;

  left: 90%;
  top: 50%;

  -webkit-transform: scale(0.6);
  -moz-transform: scale(0.6);
  transform: scale(0.6);
}

.x10 {
  -webkit-animation: animateBubble 26s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  -moz-animation: animateBubble 26s linear infinite,
    sideWays 2s ease-in-out infinite alternate;
  animation: animateBubble 26s linear infinite,
    sideWays 2s ease-in-out infinite alternate;

  left: 80%;
  top: 80%;

  -webkit-transform: scale(0.3);
  -moz-transform: scale(0.3);
  transform: scale(0.3);
}

/* OBJECTS */

.bubble {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;

  -webkit-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2),
    inset 0px 10px 30px 5px rgba(255, 255, 255, 1);
  -moz-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2),
    inset 0px 10px 30px 5px rgba(255, 255, 255, 1);
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2),
    inset 0px 10px 30px 5px rgba(255, 255, 255, 1);

  height: 200px;
  position: absolute;
  width: 200px;
}

.bubble:after {
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(255, 255, 255, 0.5)),
    color-stop(70%, rgba(255, 255, 255, 0))
  ); /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#80ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;

  -webkit-box-shadow: inset 0 20px 30px rgba(255, 255, 255, 0.3);
  -moz-box-shadow: inset 0 20px 30px rgba(255, 255, 255, 0.3);
  box-shadow: inset 0 20px 30px rgba(255, 255, 255, 0.3);

  content: "";
  height: 180px;
  left: 10px;
  position: absolute;
  width: 180px;
}
</style>
